import React, { useMemo, useState } from "react";
import HorizontalTimeline from "react-horizontal-timeline";

// items: [{ date: '2025-07-01', title: 'Kuruluş', desc: 'Şirket kuruldu', link: '#' }, ...]
export default function TimelineHorizontal({ items = [] }) {
  // Tarih stringlerini ISO (YYYY-MM-DD) formatında ver; kütüphane bunu bekliyor
  const values = useMemo(() => items.map((i) => i.date), [items]);
  const [curIdx, setCurIdx] = useState(0);

  const cur = items[curIdx] || {};

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <div style={{ height: 120, margin: "40px 0" }}>
        <HorizontalTimeline
          index={curIdx}
          indexClick={setCurIdx}
          values={values}
          minEventPadding={60}
          maxEventPadding={120}
          labelWidth={80}
          styles={{
            background: "#fff",
            foreground: "#0ea5e9",
            outline: "#e5e7eb",
          }}
          getLabel={(dateStr) => {
            const d = new Date(dateStr);
            return d.getFullYear(); // sadece yıl
          }}
        />
      </div>

      {/* Seçili olay kartı */}
      <div
        style={{
          background: "#f8fafc",
          border: "1px solid #e5e7eb",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 1px 2px rgba(0,0,0,.04)",
        }}
      >
        <div className="row align-items-center">
          <div className="col-5">
            {/* Cover: doğrudan ver */}
            {cur.cover && (
              <img
                src={cur.cover}
                alt={cur.title || ""}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  borderRadius: 8,
                  marginBottom: 12,
                }}
              />
            )}
          </div>
          <div className="col-7 animated fadeIn">
            <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4, fontStyle: 'italic' }}>
              {cur.date ? new Date(cur.date).getFullYear() : ""}
            </div>
            <h3 style={{ margin: 0, marginBottom: 10 }}>{cur.title}</h3>
            {cur.desc && <div dangerouslySetInnerHTML={{ __html: cur.desc }} />}
            {cur.link && (
              <a
                href={cur.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontWeight: 600 }}
              >
                Daha fazla →
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
